import { Component, Input } from "@angular/core";

@Component({
  selector: "onsip-announcements-empty-data",
  templateUrl: "./announcements-empty-data.component.html",
  styleUrls: ["./announcements-empty-data.component.scss"],
  standalone: false
})
export class AnnouncementsEmptyDataComponent {
  @Input() pricingText!: string;
  @Input() viewsLink!: string;
}
